// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__3h-vG","sendOtp":"AuthorizeToLogin_sendOtp__16BcE"};